// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"descriptionList_listContainer__Fewv7","label":"descriptionList_label__N62PC","description":"descriptionList_description__3O9k1"};